<div class="modal-container save-cart-modal-container">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'cart.savedCart.modalInCart.title' | cxTranslate }}</h4>
      <button class="close" aria-label="Close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ 'cart.savedCart.modalInCart.subtitle' | cxTranslate }}</p>
      <app-dynamic-form
        (formGroupEmit)="updateFormGroup($event)"
        (formModelEmit)="updateFormModel($event)"
        [formGroupId]="'SAVE_CART_MODAL_FORM'"
        [static]="true"
      ></app-dynamic-form>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button type="button" class="btn secondary-btn" [ngClass]="activeLanguage$ | async" (click)="closeModal()">
        {{ 'cart.savedCart.modalInCart.cancel' | cxTranslate }}
      </button>
      <button type="button" class="btn primary-btn" [ngClass]="activeLanguage$ | async" (click)="saveCart(formGroup)">
        {{ 'cart.savedCart.modalInCart.saveButton' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
